import toLower from 'lodash/toLower';

const colors = [
  { letter: 'a', color: '#a4cfe8' },
  { letter: 'b', color: '#b31be5' },
  { letter: 'c', color: '#e89f47' },
  { letter: 'd', color: '#e234ab' },
  { letter: 'e', color: '#efec23' },
  { letter: 'f', color: '#62eaba' },
  { letter: 'g', color: '#4837c6' },
  { letter: 'h', color: '#b2ef2f' },
  { letter: 'i', color: '#5813ad' },
  { letter: 'j', color: '#90db18' },
  { letter: 'k', color: '#e5c964' },
  { letter: 'l', color: '#b3e579' },
  { letter: 'm', color: '#ffdac4' },
  { letter: 'n', color: '#5440aa' },
  { letter: 'o', color: '#9b27f4' },
  { letter: 'p', color: '#dd8bd0' },
  { letter: 'q', color: '#f08af7' },
  { letter: 'r', color: '#5df7e0' },
  { letter: 's', color: '#6ce282' },
  { letter: 't', color: '#ef9e7f' },
  { letter: 'u', color: '#30b588' },
  { letter: 'v', color: '#7fe0a3' },
  { letter: 'w', color: '#74ed96' },
  { letter: 'x', color: '#88e25a' },
  { letter: 'y', color: '#fff5b7' },
  { letter: 'z', color: '#bf3115' },
  { letter: 'å', color: '#33d61d' },
  { letter: 'ä', color: '#81efe4' },
  { letter: 'ö', color: '#ce14b2' },
];

export const getColorFromLetter = (letter) => {
  const needle = colors.find((element) => element.letter === toLower(letter));
  return needle ? needle.color : '#a4cfe8';
};
